import { HttpHeaders } from '@angular/common/http';
import packageInfo from 'package.json';

//Para llamar a este entorno:
//ng build --configuration=production  --base-href /TOWER30/app_cliente/
// o
//npm run build-prod

export const environment = {
  appVersion: '21.7-' + packageInfo.version,
  production: true,
  baseAssets: './assets/',
  baseParent: 'https://tower30.techrules.com/tower30/app_cliente ',
  baseApiParent: '/tower30api',
  angularAppsBaseURL: '/tower30/apps',
  appSetting: './assets/AppSetting.json?v=' + Date.now(),
  logoUrl:
    './assets/img/' + localStorage.getItem('Domain') + '/WealthRules-265px.png',
  logoWhiteUrl:
    './assets/img/' +
    localStorage.getItem('Domain') +
    '/WealthRules-White-530px.png',
  logoWhiteShortUrl:
    './assets/img/' + localStorage.getItem('Domain') + '/WR_white.png',

  defaultValues: {
    language: 'en-GB',
    domain: 'TR',
    sessionToken: '',
    clientId: '',
    clientCode: '',
    portfolioCode: '',
    formatsTech:
      '[",",".",",",2,"€","s", "R","R","U",0,-10000,"-","+","L", "%","dd/MM/yyyy"]',
    conditionalFormats:
      '[{"AssetTypes":"3,7,8,A,Á,AR,B,BSE,BSU,C,D,DB,E,È,É,F,FI,G,H,I,Í,M,N,O,Ó,OT,P,PE,Q,R,RE,S,SIC,T,U,Ú,V,W,X,Z,","Currencies":"AED,ARS,AUD,BGN,BMD,BRL,BSD,CAD,CHF,CLF,CLP,CNH,CNY,CRC,CZK,DKK,EEK,EGP,EUR,GBP,HKD,HRK,HUF,IDR,ILS,INR,ISK,JPY,KES,KRW,KZD,LTL,LVL,MAD,MXN,MYR,NOK,NZD,PAB,PEN,PLN,ROL,RUB,SAR,SEK,SGD,SKK,THB,TRL,TRY,TWD,UAH,UND,USc,USD,ZAR,","PriceDecimalNumber":2,"PricePattern":"#,0.00","ValuationDecimalNumber":2,"ValuationPattern":"#,0.00"}]',
    GroupSeparator: '.',
    DateFormat: 'dd/MM/yyyy',
    DecimalSeparator: ',',
    NEGATIVE_SYMBOL: '-',
    NUMBER_OF_DECIMAL: 2,
    tuplesNumber: 30,
    isProductive: true,
  },

  services: {
    paths: {
      validation_login_client: '/api/login/client_login',
      user_sendresetpassmailclient: '/api/login/user_sendresetpassmailclient',
      get_client_data: '/api/client/get_clientdata',
      get_portfolios: '/api/client/get_clientportfolios',
      get_portfolioData: '/apirest/portal/portfolio/{portfoliocode}',
      get_portfolioanalysis: '/api/portfolio/get_portfolioanalysis',
      get_fixedperiods: '/apirest/portal/portfolio/{portfoliocode}/periods',
      get_portfolioPdfUrlReport: '/api/portfolio/get_portfolioPdfUrlReport',
      get_clientportfoliosdistrib: '/api/client/get_clientportfoliosdistrib',
      update_alias_contract: '/apirest/portal/portfolio/{portfoliocode}/alias',
      get_manualdocuments: '/api/client/get_manualdocuments',
      get_manualdocument_refdata: '/api/client/get_manualdocument_refdata',
      get_manualdocumentfile: '/api/client/get_manualdocumentfile',
      client_validatetokenmodifypassword:
        '/api/Login/client_validatetokenmodifypassword',
      client_modifypassword: '/api/Login/client_modifypassword',
      createaccount: '/apirest/onboarding',
      apirest_client_login: '/portal/login',
      apirest_get_client_data: '/portal/client',
      apirest_get_portfolios: '/portal/client/portfolio',
      apirest_eval_refdata: '/portal/eval/referencedata',
      apirest_eval: '/portal/eval/goal',
      apirest_fees: '/portal/eval/{type}/{profileid}/fees',
      apirest_riskprofile: '/eval/{type}/riskprofile ',
      apirest_profile_analysis:
        '/portal/eval/{type}/{profileid}/analysis?amount={amount} ',
      apirest_goal: '/portal/client/goal',
      apirest_goal_portfolio: '/portal/client/goal/{goalid}/portfolio',
      apirest_funding: '/portal/portfolio/{portfoliocode}/funding',
      apirest_checkMail: '/apirest/onboarding/client',
      activateaccount: '/apirest/onboarding',
      automatic_login: '/apirest/portal/login',
      activatebysms: '/apirest/activatebysms',
      resendsms: '/apirest/resendsms',
      api_questionnaire_get_investor_profile:
        '/apirest/portal/questionnarie/investorprofile',
      api_questionnaire_evaluate_profile:
        '/apirest/portal/questionnarie/evaluateprofile',
      apirest_get_enumeration: '/apirest/portal/enumeration',
      apirest_full_client_data: '/apirest/portal/onboarding/client/data',
      apirest_get_what_legaldocuments: '/apirest/portal/client/legaldocuments',
      apirest_upload_document: '/apirest/portal/client/document',
      apirest_upload_document_proofAddress:
        '/apirest/portal/client/proofofaddress',
      apirest_set_step:
        '/apirest/portal/portfolio/{PortfolioCode}/onboarding/step',
      apirest_get_custodio_doc:
        '/apirest/portal/onboarding/custodian/{custodian}/document',
      apirest_finalize_onboarding:
        '/apirest/portal/portfolio/{portfoliocode}/onboarding',
      apirest_currencies: '/apirest/portal/common/currency',
      apirest_minimun: '/apirest/portal/modelportfolio/{modelportfoliocode}',
    },
  },
  httpOptions: {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  },
  httpHeader(session: any) {
    let headers: HttpHeaders = environment.httpOptions.headers;
    headers = headers.append('Tower30-SessionToken', session.sessionToken);
    headers = headers.append('Tower30-ClientCode', session.clientCode);
    headers = headers.append('Tower30-Domain', session.domain);
    headers = headers.append('Tower30-Language', session.language);
    headers = headers.append('Tower30-Captchatoken', '');
    headers = headers.append('Access-Control-Allow-Origin', '*');
    headers = headers.append(
      'Access-Control-Allow-Headers',
      'Origin, X-Requested-With, Content-Type, Accept'
    );
    headers = headers.append(
      'Access-Control-Allow-Methods',
      'GET, POST, PUT, DELETE'
    );

    return headers;
  },
};
